import styled from 'styled-components';
import panelTheme from '../panel/theme';
var theme = {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "o5nxe7-0"
  })(["width:100%;"]),
  Panel: panelTheme
};
export default theme;